import { TriangleAlert, FileText } from "lucide-react";

export default function RiskDisclaimer() {
  return (
    <section className="relative py-10 sm:py-12 border-y border-[#23232a]/60 bg-[#0c0c10]">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-start gap-4">
          <div className="w-10 h-10 rounded-lg grid place-items-center border border-[#23232a] bg-[rgba(255,180,0,.05)] shrink-0">
            <TriangleAlert className="w-4.5 h-4.5 text-[#ffb400]" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-mono text-[10px] sm:text-[11px] uppercase tracking-widest text-[#ffb400]">
              Risk disclaimer
            </div>
            <p className="text-[12px] sm:text-[13px] text-[color:var(--ink-dim)] mt-2 leading-relaxed">
              <strong className="text-white">Trading involves substantial risk of loss</strong> and is not suitable for every investor.
              The valuation of foreign exchange, CFDs and gold (XAUUSD) may fluctuate and you may lose all of your invested capital.
              No Expert Advisor — including Prop Passer Gold — can guarantee profit or guarantee passing any prop firm challenge.
              Past performance is not indicative of future results. All testimonials reflect individual experiences and are not typical.
              Always test the EA on a demo account, read your prop firm's official rule PDF, and only trade money you can afford to lose.
            </p>
            <div className="mt-3 flex flex-wrap gap-3 text-[11px] text-[color:var(--ink-mute)]">
              <span className="inline-flex items-center gap-1.5"><FileText className="w-3 h-3" /> Educational software</span>
              <span className="inline-flex items-center gap-1.5"><FileText className="w-3 h-3" /> Not investment advice</span>
              <span className="inline-flex items-center gap-1.5"><FileText className="w-3 h-3" /> Not regulated as a broker</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
